const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailsBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.28,343.24c.07-.18,444.94-3.48,444.68,0-.22,2.82,30.21-113.3-67-107.63,0,0,21.76-46.59-10.44-74.31-34-29.27-77.37-4.05-77.37-4.05s-38.8-96.2-126.6-66.93c-100.33,33.44-73.24,148.19-73.24,148.19S24.86,230.93,26.28,343.24Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.28,343.24c.07-.18,444.94-3.48,444.68,0-.22,2.82,30.21-113.3-67-107.63,0,0,21.76-46.59-10.44-74.31-34-29.27-77.37-4.05-77.37-4.05s-38.8-96.2-126.6-66.93c-100.33,33.44-73.24,148.19-73.24,148.19S24.86,230.93,26.28,343.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-details--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.18,111.37l-37-5.15-3.4,24.15,36.57,6.1ZM147,112l-18.14,8.72-14.77-13.3Zm-37.12,17.53,3.07-21.84,15.74,14.19L148,112.61l-3.49,22.75Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.18,111.37l-37-5.15-3.4,24.15,36.57,6.1ZM147,112l-18.14,8.72-14.77-13.3Zm-37.12,17.53,3.07-21.84,15.74,14.19L148,112.61l-3.49,22.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.94,88.46,300.5,115.09l39.18,47.18.31.37L372,135.3Zm39,45.91-34-9.2-4.34-34.52ZM301.84,115.2l28.69-25.09,4.5,35.82,35.31,9.55-30.23,25.79Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.94,88.46,300.5,115.09l39.18,47.18.31.37L372,135.3Zm39,45.91-34-9.2-4.34-34.52ZM301.84,115.2l28.69-25.09,4.5,35.82,35.31,9.55-30.23,25.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.55,226.13h0a.5.5,0,0,1-.48-.49c0-.65,0-1.29,0-1.94a.49.49,0,0,1,1,0c0,.65,0,1.29,0,1.93A.49.49,0,0,1,60.55,226.13Zm.2-6.77h0a.48.48,0,0,1-.46-.5l.09-1.94a.49.49,0,0,1,.51-.45.48.48,0,0,1,.46.5c0,.65-.07,1.29-.09,1.93A.49.49,0,0,1,60.75,219.36Zm.39-6.75h0a.49.49,0,0,1-.45-.51l.15-1.93a.48.48,0,0,1,.52-.45.49.49,0,0,1,.44.52c0,.64-.1,1.28-.14,1.93A.49.49,0,0,1,61.14,212.61Zm.56-6.75h0a.49.49,0,0,1-.44-.53c.07-.64.13-1.28.2-1.93a.48.48,0,1,1,1,.11c-.07.64-.13,1.28-.2,1.92A.47.47,0,0,1,61.7,205.86Zm.76-6.72H62.4a.49.49,0,0,1-.42-.54c.08-.64.17-1.28.25-1.92a.49.49,0,0,1,.55-.41.48.48,0,0,1,.41.54c-.08.64-.17,1.28-.25,1.91A.49.49,0,0,1,62.46,199.14Zm1-6.7h-.08a.48.48,0,0,1-.4-.55c.1-.64.2-1.28.31-1.91a.48.48,0,1,1,1,.16c-.1.63-.21,1.26-.31,1.9A.48.48,0,0,1,63.42,192.44Zm1.16-6.67h-.1a.48.48,0,0,1-.38-.56c.12-.64.24-1.27.37-1.9a.47.47,0,0,1,.57-.38.48.48,0,0,1,.38.57c-.13.63-.25,1.26-.37,1.89A.48.48,0,0,1,64.58,185.77ZM66,179.14h-.11a.47.47,0,0,1-.36-.57c.14-.64.28-1.26.43-1.89a.48.48,0,1,1,.94.22c-.14.62-.29,1.25-.43,1.88A.48.48,0,0,1,66,179.14Zm1.59-6.57-.12,0a.47.47,0,0,1-.34-.59c.16-.62.32-1.25.49-1.87a.49.49,0,0,1,.94.25c-.17.62-.34,1.25-.5,1.87A.48.48,0,0,1,67.54,172.57Zm1.83-6.52a.32.32,0,0,1-.14,0,.48.48,0,0,1-.33-.6l.57-1.85a.48.48,0,1,1,.92.28c-.19.62-.38,1.23-.56,1.85A.48.48,0,0,1,69.37,166.05Zm2-6.44-.15,0A.48.48,0,0,1,71,159c.2-.62.42-1.23.63-1.84a.48.48,0,0,1,.62-.29.48.48,0,0,1,.29.61l-.63,1.83A.48.48,0,0,1,71.42,159.61Zm2.3-6.37-.17,0a.5.5,0,0,1-.28-.63c.23-.6.47-1.2.71-1.8a.48.48,0,0,1,.89.35c-.23.6-.47,1.2-.69,1.8A.5.5,0,0,1,73.72,153.24ZM76.27,147a.43.43,0,0,1-.19,0,.49.49,0,0,1-.26-.64l.78-1.77a.48.48,0,1,1,.88.39l-.77,1.77A.48.48,0,0,1,76.27,147Zm2.79-6.16a.49.49,0,0,1-.43-.7c.28-.58.56-1.16.85-1.74a.48.48,0,0,1,.65-.22.49.49,0,0,1,.21.65l-.84,1.73A.49.49,0,0,1,79.06,140.81Zm3.06-6.05a.46.46,0,0,1-.23-.06.47.47,0,0,1-.2-.65c.3-.57.61-1.14.92-1.71a.49.49,0,0,1,.85.47l-.92,1.69A.46.46,0,0,1,82.12,134.76Zm3.31-5.9a.47.47,0,0,1-.25-.07.49.49,0,0,1-.17-.66c.33-.56.67-1.11,1-1.67a.47.47,0,0,1,.66-.16.49.49,0,0,1,.16.67q-.51.82-1,1.65A.5.5,0,0,1,85.43,128.86ZM89,123.11a.47.47,0,0,1-.27-.08.48.48,0,0,1-.13-.67c.35-.54.71-1.07,1.07-1.61a.5.5,0,0,1,.68-.13.48.48,0,0,1,.13.67c-.37.53-.72,1.07-1.08,1.61A.46.46,0,0,1,89,123.11Zm3.86-5.56a.52.52,0,0,1-.29-.09.49.49,0,0,1-.1-.68l1.15-1.56a.48.48,0,1,1,.77.58l-1.14,1.55A.49.49,0,0,1,92.88,117.55ZM97,112.17a.43.43,0,0,1-.3-.11.49.49,0,0,1-.08-.68l1.23-1.5a.48.48,0,0,1,.75.61L97.37,112A.49.49,0,0,1,97,112.17Zm4.36-5.18a.51.51,0,0,1-.32-.12.48.48,0,0,1,0-.68c.43-.48.86-1,1.3-1.44a.48.48,0,0,1,.68,0,.49.49,0,0,1,0,.69c-.43.47-.86.95-1.28,1.43A.49.49,0,0,1,101.35,107Zm211.76-1.58a.39.39,0,0,1-.18,0l-1.79-.73a.48.48,0,1,1,.37-.89l1.79.73a.49.49,0,0,1,.26.63A.47.47,0,0,1,313.11,105.41Zm-6.25-2.6a.57.57,0,0,1-.18,0L304.9,102a.49.49,0,0,1-.26-.64.48.48,0,0,1,.64-.25l1.77.76a.48.48,0,0,1,.26.63A.49.49,0,0,1,306.86,102.81ZM106,102a.47.47,0,0,1-.34-.13.49.49,0,0,1,0-.69L107,99.83a.49.49,0,0,1,.69.69c-.46.45-.91.91-1.36,1.37A.49.49,0,0,1,106,102Zm194.69-1.9a.45.45,0,0,1-.19,0l-1.77-.78a.48.48,0,0,1-.25-.64.49.49,0,0,1,.64-.24l1.77.78a.49.49,0,0,1-.2.93Zm-6.18-2.76a.49.49,0,0,1-.2-.05l-1.76-.79a.49.49,0,0,1-.24-.64.48.48,0,0,1,.64-.24l1.76.79a.49.49,0,0,1,.24.64A.48.48,0,0,1,294.47,97.37ZM110.79,97.3a.44.44,0,0,1-.35-.16.49.49,0,0,1,0-.68l1.43-1.31a.48.48,0,0,1,.68,0,.49.49,0,0,1,0,.69l-1.42,1.3A.46.46,0,0,1,110.79,97.3Zm177.52-2.73a.46.46,0,0,1-.2,0l-1.76-.8a.48.48,0,0,1,.4-.88l1.76.8a.49.49,0,0,1-.2.93ZM115.85,92.81a.49.49,0,0,1-.31-.86L117,90.71a.49.49,0,0,1,.68.07.48.48,0,0,1-.07.68l-1.48,1.23A.47.47,0,0,1,115.85,92.81Zm166.31-1.07a.52.52,0,0,1-.21,0l-1.75-.8a.49.49,0,0,1-.24-.65.48.48,0,0,1,.64-.23l1.76.8a.47.47,0,0,1,.23.64A.47.47,0,0,1,282.16,91.74ZM276,88.93a.71.71,0,0,1-.2,0L274,88.08a.48.48,0,0,1-.24-.63.48.48,0,0,1,.64-.25l1.76.81a.48.48,0,0,1,.24.64A.5.5,0,0,1,276,88.93Zm-154.87-.35a.49.49,0,0,1-.39-.2.47.47,0,0,1,.1-.67l1.55-1.17a.48.48,0,0,1,.67.11.47.47,0,0,1-.1.67l-1.54,1.16A.53.53,0,0,1,121.13,88.58Zm148.7-2.44a.51.51,0,0,1-.2,0l-1.76-.79a.48.48,0,0,1-.25-.64.49.49,0,0,1,.64-.24l1.77.79a.48.48,0,0,1,.24.64A.47.47,0,0,1,269.83,86.14ZM126.61,84.62a.46.46,0,0,1-.39-.21.47.47,0,0,1,.12-.67c.54-.37,1.07-.73,1.61-1.08a.48.48,0,0,1,.67.13.47.47,0,0,1-.14.67l-1.59,1.08A.57.57,0,0,1,126.61,84.62Zm137-1.21a.41.41,0,0,1-.19,0l-1.78-.76a.49.49,0,0,1-.25-.64.48.48,0,0,1,.63-.25l1.78.76a.48.48,0,0,1,.25.64A.49.49,0,0,1,263.64,83.41ZM132.3,81a.48.48,0,0,1-.41-.23.49.49,0,0,1,.16-.67l1.66-1a.48.48,0,1,1,.49.83c-.55.33-1.1.65-1.65,1A.45.45,0,0,1,132.3,81Zm125.11-.19a.43.43,0,0,1-.19,0L255.44,80a.48.48,0,1,1,.36-.9l1.79.74a.48.48,0,0,1-.18.93Zm-6.28-2.54a.51.51,0,0,1-.17,0l-1.8-.7a.48.48,0,1,1,.35-.9l1.8.7a.48.48,0,0,1,.27.63A.47.47,0,0,1,251.13,78.23Zm-112.95-.62a.48.48,0,0,1-.23-.91c.57-.31,1.14-.6,1.72-.9a.48.48,0,0,1,.44.86l-1.7.89A.53.53,0,0,1,138.18,77.61ZM244.8,75.83a.45.45,0,0,1-.16,0l-1.82-.65a.48.48,0,0,1,.33-.91l1.82.65a.5.5,0,0,1,.29.63A.49.49,0,0,1,244.8,75.83ZM144.23,74.6a.49.49,0,0,1-.2-.93l1.77-.79a.47.47,0,0,1,.63.24.48.48,0,0,1-.24.64l-1.76.79A.46.46,0,0,1,144.23,74.6Zm94.19-1a.45.45,0,0,1-.16,0L236.43,73a.48.48,0,1,1,.3-.92l1.84.62a.49.49,0,0,1,.31.61A.49.49,0,0,1,238.42,73.59Zm-88-1.65a.5.5,0,0,1-.45-.31.47.47,0,0,1,.28-.62l1.81-.7a.49.49,0,0,1,.62.29.48.48,0,0,1-.28.62q-.9.33-1.8.69A.57.57,0,0,1,150.45,71.94ZM232,71.52a.34.34,0,0,1-.14,0L230,71a.48.48,0,0,1-.33-.6.49.49,0,0,1,.6-.33l1.86.56a.48.48,0,0,1-.14.94Zm-6.51-1.85-.13,0-1.86-.49a.48.48,0,1,1,.24-.93l1.87.49a.49.49,0,0,1,.35.59A.5.5,0,0,1,225.46,69.67Zm-68.64,0a.49.49,0,0,1-.46-.33.49.49,0,0,1,.31-.61c.62-.2,1.24-.4,1.86-.58a.48.48,0,0,1,.6.32.48.48,0,0,1-.32.6l-1.84.58Zm62.07-1.61h-.11l-1.89-.42a.48.48,0,1,1,.2-.94l1.9.41a.49.49,0,0,1,.37.58A.48.48,0,0,1,218.89,68.05Zm-55.57-.27a.5.5,0,0,1-.47-.36.49.49,0,0,1,.35-.59l1.89-.47a.48.48,0,0,1,.58.36.5.5,0,0,1-.36.59c-.62.14-1.25.3-1.87.46Zm48.93-1.08h-.09l-1.9-.33a.48.48,0,0,1,.16-1l1.92.33a.48.48,0,0,1-.09,1Zm-42.32-.38a.47.47,0,0,1-.47-.4.48.48,0,0,1,.38-.56l1.92-.34a.48.48,0,1,1,.16,1l-1.9.34Zm35.63-.67h-.06c-.64-.09-1.27-.17-1.91-.24a.48.48,0,1,1,.11-1l1.93.24a.48.48,0,0,1,.41.54A.49.49,0,0,1,205.56,65.65Zm-28.93-.36a.48.48,0,0,1-.06-1l1.94-.22a.49.49,0,0,1,.53.44.5.5,0,0,1-.44.53c-.64.06-1.28.13-1.91.21Zm22.2-.36h0l-1.92-.14a.48.48,0,0,1-.45-.51.49.49,0,0,1,.52-.45l1.93.14a.48.48,0,0,1,.45.52A.49.49,0,0,1,198.83,64.93Zm-15.45-.22a.49.49,0,0,1,0-1l1.94-.08a.46.46,0,0,1,.5.46.48.48,0,0,1-.46.5c-.65,0-1.29,0-1.93.09Zm8.7-.13h0l-1.92,0a.48.48,0,1,1,0-1h0l1.94,0a.47.47,0,0,1,.47.49A.48.48,0,0,1,192.08,64.58Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.55,226.13h0a.5.5,0,0,1-.48-.49c0-.65,0-1.29,0-1.94a.49.49,0,0,1,1,0c0,.65,0,1.29,0,1.93A.49.49,0,0,1,60.55,226.13Zm.2-6.77h0a.48.48,0,0,1-.46-.5l.09-1.94a.49.49,0,0,1,.51-.45.48.48,0,0,1,.46.5c0,.65-.07,1.29-.09,1.93A.49.49,0,0,1,60.75,219.36Zm.39-6.75h0a.49.49,0,0,1-.45-.51l.15-1.93a.48.48,0,0,1,.52-.45.49.49,0,0,1,.44.52c0,.64-.1,1.28-.14,1.93A.49.49,0,0,1,61.14,212.61Zm.56-6.75h0a.49.49,0,0,1-.44-.53c.07-.64.13-1.28.2-1.93a.48.48,0,1,1,1,.11c-.07.64-.13,1.28-.2,1.92A.47.47,0,0,1,61.7,205.86Zm.76-6.72H62.4a.49.49,0,0,1-.42-.54c.08-.64.17-1.28.25-1.92a.49.49,0,0,1,.55-.41.48.48,0,0,1,.41.54c-.08.64-.17,1.28-.25,1.91A.49.49,0,0,1,62.46,199.14Zm1-6.7h-.08a.48.48,0,0,1-.4-.55c.1-.64.2-1.28.31-1.91a.48.48,0,1,1,1,.16c-.1.63-.21,1.26-.31,1.9A.48.48,0,0,1,63.42,192.44Zm1.16-6.67h-.1a.48.48,0,0,1-.38-.56c.12-.64.24-1.27.37-1.9a.47.47,0,0,1,.57-.38.48.48,0,0,1,.38.57c-.13.63-.25,1.26-.37,1.89A.48.48,0,0,1,64.58,185.77ZM66,179.14h-.11a.47.47,0,0,1-.36-.57c.14-.64.28-1.26.43-1.89a.48.48,0,1,1,.94.22c-.14.62-.29,1.25-.43,1.88A.48.48,0,0,1,66,179.14Zm1.59-6.57-.12,0a.47.47,0,0,1-.34-.59c.16-.62.32-1.25.49-1.87a.49.49,0,0,1,.94.25c-.17.62-.34,1.25-.5,1.87A.48.48,0,0,1,67.54,172.57Zm1.83-6.52a.32.32,0,0,1-.14,0,.48.48,0,0,1-.33-.6l.57-1.85a.48.48,0,1,1,.92.28c-.19.62-.38,1.23-.56,1.85A.48.48,0,0,1,69.37,166.05Zm2-6.44-.15,0A.48.48,0,0,1,71,159c.2-.62.42-1.23.63-1.84a.48.48,0,0,1,.62-.29.48.48,0,0,1,.29.61l-.63,1.83A.48.48,0,0,1,71.42,159.61Zm2.3-6.37-.17,0a.5.5,0,0,1-.28-.63c.23-.6.47-1.2.71-1.8a.48.48,0,0,1,.89.35c-.23.6-.47,1.2-.69,1.8A.5.5,0,0,1,73.72,153.24ZM76.27,147a.43.43,0,0,1-.19,0,.49.49,0,0,1-.26-.64l.78-1.77a.48.48,0,1,1,.88.39l-.77,1.77A.48.48,0,0,1,76.27,147Zm2.79-6.16a.49.49,0,0,1-.43-.7c.28-.58.56-1.16.85-1.74a.48.48,0,0,1,.65-.22.49.49,0,0,1,.21.65l-.84,1.73A.49.49,0,0,1,79.06,140.81Zm3.06-6.05a.46.46,0,0,1-.23-.06.47.47,0,0,1-.2-.65c.3-.57.61-1.14.92-1.71a.49.49,0,0,1,.85.47l-.92,1.69A.46.46,0,0,1,82.12,134.76Zm3.31-5.9a.47.47,0,0,1-.25-.07.49.49,0,0,1-.17-.66c.33-.56.67-1.11,1-1.67a.47.47,0,0,1,.66-.16.49.49,0,0,1,.16.67q-.51.82-1,1.65A.5.5,0,0,1,85.43,128.86ZM89,123.11a.47.47,0,0,1-.27-.08.48.48,0,0,1-.13-.67c.35-.54.71-1.07,1.07-1.61a.5.5,0,0,1,.68-.13.48.48,0,0,1,.13.67c-.37.53-.72,1.07-1.08,1.61A.46.46,0,0,1,89,123.11Zm3.86-5.56a.52.52,0,0,1-.29-.09.49.49,0,0,1-.1-.68l1.15-1.56a.48.48,0,1,1,.77.58l-1.14,1.55A.49.49,0,0,1,92.88,117.55ZM97,112.17a.43.43,0,0,1-.3-.11.49.49,0,0,1-.08-.68l1.23-1.5a.48.48,0,0,1,.75.61L97.37,112A.49.49,0,0,1,97,112.17Zm4.36-5.18a.51.51,0,0,1-.32-.12.48.48,0,0,1,0-.68c.43-.48.86-1,1.3-1.44a.48.48,0,0,1,.68,0,.49.49,0,0,1,0,.69c-.43.47-.86.95-1.28,1.43A.49.49,0,0,1,101.35,107Zm211.76-1.58a.39.39,0,0,1-.18,0l-1.79-.73a.48.48,0,1,1,.37-.89l1.79.73a.49.49,0,0,1,.26.63A.47.47,0,0,1,313.11,105.41Zm-6.25-2.6a.57.57,0,0,1-.18,0L304.9,102a.49.49,0,0,1-.26-.64.48.48,0,0,1,.64-.25l1.77.76a.48.48,0,0,1,.26.63A.49.49,0,0,1,306.86,102.81ZM106,102a.47.47,0,0,1-.34-.13.49.49,0,0,1,0-.69L107,99.83a.49.49,0,0,1,.69.69c-.46.45-.91.91-1.36,1.37A.49.49,0,0,1,106,102Zm194.69-1.9a.45.45,0,0,1-.19,0l-1.77-.78a.48.48,0,0,1-.25-.64.49.49,0,0,1,.64-.24l1.77.78a.49.49,0,0,1-.2.93Zm-6.18-2.76a.49.49,0,0,1-.2-.05l-1.76-.79a.49.49,0,0,1-.24-.64.48.48,0,0,1,.64-.24l1.76.79a.49.49,0,0,1,.24.64A.48.48,0,0,1,294.47,97.37ZM110.79,97.3a.44.44,0,0,1-.35-.16.49.49,0,0,1,0-.68l1.43-1.31a.48.48,0,0,1,.68,0,.49.49,0,0,1,0,.69l-1.42,1.3A.46.46,0,0,1,110.79,97.3Zm177.52-2.73a.46.46,0,0,1-.2,0l-1.76-.8a.48.48,0,0,1,.4-.88l1.76.8a.49.49,0,0,1-.2.93ZM115.85,92.81a.49.49,0,0,1-.31-.86L117,90.71a.49.49,0,0,1,.68.07.48.48,0,0,1-.07.68l-1.48,1.23A.47.47,0,0,1,115.85,92.81Zm166.31-1.07a.52.52,0,0,1-.21,0l-1.75-.8a.49.49,0,0,1-.24-.65.48.48,0,0,1,.64-.23l1.76.8a.47.47,0,0,1,.23.64A.47.47,0,0,1,282.16,91.74ZM276,88.93a.71.71,0,0,1-.2,0L274,88.08a.48.48,0,0,1-.24-.63.48.48,0,0,1,.64-.25l1.76.81a.48.48,0,0,1,.24.64A.5.5,0,0,1,276,88.93Zm-154.87-.35a.49.49,0,0,1-.39-.2.47.47,0,0,1,.1-.67l1.55-1.17a.48.48,0,0,1,.67.11.47.47,0,0,1-.1.67l-1.54,1.16A.53.53,0,0,1,121.13,88.58Zm148.7-2.44a.51.51,0,0,1-.2,0l-1.76-.79a.48.48,0,0,1-.25-.64.49.49,0,0,1,.64-.24l1.77.79a.48.48,0,0,1,.24.64A.47.47,0,0,1,269.83,86.14ZM126.61,84.62a.46.46,0,0,1-.39-.21.47.47,0,0,1,.12-.67c.54-.37,1.07-.73,1.61-1.08a.48.48,0,0,1,.67.13.47.47,0,0,1-.14.67l-1.59,1.08A.57.57,0,0,1,126.61,84.62Zm137-1.21a.41.41,0,0,1-.19,0l-1.78-.76a.49.49,0,0,1-.25-.64.48.48,0,0,1,.63-.25l1.78.76a.48.48,0,0,1,.25.64A.49.49,0,0,1,263.64,83.41ZM132.3,81a.48.48,0,0,1-.41-.23.49.49,0,0,1,.16-.67l1.66-1a.48.48,0,1,1,.49.83c-.55.33-1.1.65-1.65,1A.45.45,0,0,1,132.3,81Zm125.11-.19a.43.43,0,0,1-.19,0L255.44,80a.48.48,0,1,1,.36-.9l1.79.74a.48.48,0,0,1-.18.93Zm-6.28-2.54a.51.51,0,0,1-.17,0l-1.8-.7a.48.48,0,1,1,.35-.9l1.8.7a.48.48,0,0,1,.27.63A.47.47,0,0,1,251.13,78.23Zm-112.95-.62a.48.48,0,0,1-.23-.91c.57-.31,1.14-.6,1.72-.9a.48.48,0,0,1,.44.86l-1.7.89A.53.53,0,0,1,138.18,77.61ZM244.8,75.83a.45.45,0,0,1-.16,0l-1.82-.65a.48.48,0,0,1,.33-.91l1.82.65a.5.5,0,0,1,.29.63A.49.49,0,0,1,244.8,75.83ZM144.23,74.6a.49.49,0,0,1-.2-.93l1.77-.79a.47.47,0,0,1,.63.24.48.48,0,0,1-.24.64l-1.76.79A.46.46,0,0,1,144.23,74.6Zm94.19-1a.45.45,0,0,1-.16,0L236.43,73a.48.48,0,1,1,.3-.92l1.84.62a.49.49,0,0,1,.31.61A.49.49,0,0,1,238.42,73.59Zm-88-1.65a.5.5,0,0,1-.45-.31.47.47,0,0,1,.28-.62l1.81-.7a.49.49,0,0,1,.62.29.48.48,0,0,1-.28.62q-.9.33-1.8.69A.57.57,0,0,1,150.45,71.94ZM232,71.52a.34.34,0,0,1-.14,0L230,71a.48.48,0,0,1-.33-.6.49.49,0,0,1,.6-.33l1.86.56a.48.48,0,0,1-.14.94Zm-6.51-1.85-.13,0-1.86-.49a.48.48,0,1,1,.24-.93l1.87.49a.49.49,0,0,1,.35.59A.5.5,0,0,1,225.46,69.67Zm-68.64,0a.49.49,0,0,1-.46-.33.49.49,0,0,1,.31-.61c.62-.2,1.24-.4,1.86-.58a.48.48,0,0,1,.6.32.48.48,0,0,1-.32.6l-1.84.58Zm62.07-1.61h-.11l-1.89-.42a.48.48,0,1,1,.2-.94l1.9.41a.49.49,0,0,1,.37.58A.48.48,0,0,1,218.89,68.05Zm-55.57-.27a.5.5,0,0,1-.47-.36.49.49,0,0,1,.35-.59l1.89-.47a.48.48,0,0,1,.58.36.5.5,0,0,1-.36.59c-.62.14-1.25.3-1.87.46Zm48.93-1.08h-.09l-1.9-.33a.48.48,0,0,1,.16-1l1.92.33a.48.48,0,0,1-.09,1Zm-42.32-.38a.47.47,0,0,1-.47-.4.48.48,0,0,1,.38-.56l1.92-.34a.48.48,0,1,1,.16,1l-1.9.34Zm35.63-.67h-.06c-.64-.09-1.27-.17-1.91-.24a.48.48,0,1,1,.11-1l1.93.24a.48.48,0,0,1,.41.54A.49.49,0,0,1,205.56,65.65Zm-28.93-.36a.48.48,0,0,1-.06-1l1.94-.22a.49.49,0,0,1,.53.44.5.5,0,0,1-.44.53c-.64.06-1.28.13-1.91.21Zm22.2-.36h0l-1.92-.14a.48.48,0,0,1-.45-.51.49.49,0,0,1,.52-.45l1.93.14a.48.48,0,0,1,.45.52A.49.49,0,0,1,198.83,64.93Zm-15.45-.22a.49.49,0,0,1,0-1l1.94-.08a.46.46,0,0,1,.5.46.48.48,0,0,1-.46.5c-.65,0-1.29,0-1.93.09Zm8.7-.13h0l-1.92,0a.48.48,0,1,1,0-1h0l1.94,0a.47.47,0,0,1,.47.49A.48.48,0,0,1,192.08,64.58Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,245.74a.54.54,0,0,1-.21-.05.48.48,0,0,1-.22-.65c.28-.58.56-1.16.83-1.74a.49.49,0,0,1,.64-.23.48.48,0,0,1,.24.64l-.84,1.75A.49.49,0,0,1,436,245.74Zm2.81-6.16a.65.65,0,0,1-.19,0,.49.49,0,0,1-.26-.64c.25-.59.5-1.18.74-1.77a.48.48,0,0,1,.9.36c-.25.6-.49,1.2-.75,1.79A.46.46,0,0,1,438.84,239.58Zm2.46-6.31a.41.41,0,0,1-.16,0,.47.47,0,0,1-.3-.61c.22-.61.43-1.21.64-1.82a.48.48,0,0,1,.61-.31.49.49,0,0,1,.3.62c-.21.61-.42,1.22-.64,1.83A.47.47,0,0,1,441.3,233.27Zm2.09-6.43-.14,0a.48.48,0,0,1-.32-.6c.18-.62.35-1.24.52-1.86a.49.49,0,0,1,.94.26c-.18.62-.35,1.25-.54,1.87A.48.48,0,0,1,443.39,226.84Zm1.71-6.55-.11,0a.49.49,0,0,1-.37-.58c.15-.62.29-1.25.42-1.88a.48.48,0,0,1,.57-.37.47.47,0,0,1,.37.57c-.13.64-.27,1.27-.41,1.9A.49.49,0,0,1,445.1,220.29Zm1.29-6.65h-.07a.48.48,0,0,1-.4-.56c.1-.63.2-1.27.29-1.9a.47.47,0,0,1,.54-.41.48.48,0,0,1,.41.55c-.09.64-.19,1.28-.29,1.92A.48.48,0,0,1,446.39,213.64Zm.87-6.71h-.05a.48.48,0,0,1-.43-.53c.06-.64.11-1.28.16-1.92a.48.48,0,0,1,1,.07c0,.65-.1,1.3-.16,1.94A.49.49,0,0,1,447.26,206.93Zm.4-6.76h0a.47.47,0,0,1-.47-.49c0-.64,0-1.28,0-1.93a.49.49,0,0,1,.49-.48h0a.48.48,0,0,1,.48.49c0,.65,0,1.29,0,1.94A.48.48,0,0,1,447.66,200.17Zm-.08-6.76a.49.49,0,0,1-.49-.46c0-.64-.07-1.28-.11-1.92a.48.48,0,0,1,.45-.52.49.49,0,0,1,.51.45c.05.65.09,1.29.12,1.94a.49.49,0,0,1-.46.51Zm-.6-6.74a.49.49,0,0,1-.48-.43c-.08-.63-.17-1.27-.26-1.9a.48.48,0,0,1,.4-.55.49.49,0,0,1,.55.4c.1.65.19,1.29.27,1.93a.47.47,0,0,1-.42.54ZM445.86,180a.48.48,0,0,1-.48-.38c-.13-.63-.27-1.25-.42-1.87a.5.5,0,0,1,.36-.59.48.48,0,0,1,.58.36c.15.63.3,1.27.43,1.9a.47.47,0,0,1-.37.57Zm-1.69-6.55a.47.47,0,0,1-.46-.34c-.19-.61-.38-1.22-.58-1.83A.48.48,0,1,1,444,171c.21.62.4,1.24.59,1.86a.48.48,0,0,1-.32.6A.34.34,0,0,1,444.17,173.44Zm-2.25-6.38a.5.5,0,0,1-.45-.3c-.23-.6-.48-1.19-.73-1.78a.48.48,0,0,1,.25-.63.48.48,0,0,1,.64.25c.25.6.5,1.19.74,1.8a.47.47,0,0,1-.27.62A.39.39,0,0,1,441.92,167.06Zm-2.78-6.17a.46.46,0,0,1-.43-.26c-.29-.57-.59-1.14-.89-1.71a.48.48,0,0,1,.19-.65.49.49,0,0,1,.66.19c.31.58.61,1.15.9,1.73a.48.48,0,0,1-.22.65A.41.41,0,0,1,439.14,160.89Zm-3.32-5.9a.48.48,0,0,1-.41-.23c-.33-.54-.68-1.08-1-1.62a.48.48,0,0,1,.14-.67.49.49,0,0,1,.67.14c.35.54.7,1.09,1,1.64a.48.48,0,0,1-.15.67A.48.48,0,0,1,435.82,155ZM432,149.41a.49.49,0,0,1-.39-.2c-.38-.51-.77-1-1.17-1.51a.48.48,0,1,1,.75-.61c.41.51.8,1,1.2,1.54a.49.49,0,0,1-.1.68A.46.46,0,0,1,432,149.41Zm-4.32-5.21a.48.48,0,0,1-.36-.16c-.43-.47-.87-.94-1.31-1.4a.48.48,0,0,1,.69-.67c.45.47.9.94,1.34,1.42a.48.48,0,0,1,0,.68A.45.45,0,0,1,427.68,144.2Zm-4.8-4.77a.52.52,0,0,1-.33-.12c-.47-.43-.95-.85-1.44-1.27a.48.48,0,0,1-.06-.68.49.49,0,0,1,.68-.05c.5.42,1,.84,1.47,1.28a.48.48,0,0,1-.32.84Zm-5.26-4.26a.47.47,0,0,1-.28-.09c-.52-.38-1-.75-1.57-1.11a.48.48,0,1,1,.54-.79c.54.36,1.07.74,1.6,1.12a.48.48,0,0,1-.29.87ZM412,131.49a.48.48,0,0,1-.24-.06L410,130.5a.47.47,0,0,1-.2-.65.48.48,0,0,1,.65-.2c.58.3,1.14.62,1.71.94a.49.49,0,0,1,.18.66A.48.48,0,0,1,412,131.49Zm-6.05-3a.41.41,0,0,1-.19,0c-.59-.26-1.18-.5-1.77-.74a.48.48,0,1,1,.36-.9c.6.24,1.2.49,1.79.75a.49.49,0,0,1-.19.93Zm-6.33-2.4a.4.4,0,0,1-.15,0c-.6-.2-1.22-.39-1.83-.57a.49.49,0,0,1,.28-.93c.62.19,1.24.38,1.86.59a.48.48,0,0,1-.16.94Zm-6.5-1.86H393c-.62-.16-1.24-.31-1.87-.45a.48.48,0,0,1,.22-.94q.94.21,1.89.45a.48.48,0,0,1,.35.58A.49.49,0,0,1,393.07,124.2Zm-6.61-1.43h-.09l-1.9-.34a.48.48,0,0,1-.39-.56.49.49,0,0,1,.56-.4l1.91.35a.48.48,0,0,1,.38.57A.47.47,0,0,1,386.46,122.77Zm-6.67-1.13h-.08l-1.91-.29a.48.48,0,0,1-.41-.54.49.49,0,0,1,.55-.41l1.92.28a.48.48,0,0,1,.4.55A.47.47,0,0,1,379.79,121.64Zm-6.71-.94H373l-1.92-.25a.49.49,0,0,1-.41-.55.48.48,0,0,1,.54-.41l1.92.25a.49.49,0,0,1-.07,1Zm-6.71-.89h-.06l-1.92-.26a.48.48,0,0,1,.13-1l1.92.26a.49.49,0,0,1-.07,1Zm-6.7-1h-.07l-1.92-.3a.49.49,0,0,1,.15-1l1.91.3a.48.48,0,0,1-.07,1Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,245.74a.54.54,0,0,1-.21-.05.48.48,0,0,1-.22-.65c.28-.58.56-1.16.83-1.74a.49.49,0,0,1,.64-.23.48.48,0,0,1,.24.64l-.84,1.75A.49.49,0,0,1,436,245.74Zm2.81-6.16a.65.65,0,0,1-.19,0,.49.49,0,0,1-.26-.64c.25-.59.5-1.18.74-1.77a.48.48,0,0,1,.9.36c-.25.6-.49,1.2-.75,1.79A.46.46,0,0,1,438.84,239.58Zm2.46-6.31a.41.41,0,0,1-.16,0,.47.47,0,0,1-.3-.61c.22-.61.43-1.21.64-1.82a.48.48,0,0,1,.61-.31.49.49,0,0,1,.3.62c-.21.61-.42,1.22-.64,1.83A.47.47,0,0,1,441.3,233.27Zm2.09-6.43-.14,0a.48.48,0,0,1-.32-.6c.18-.62.35-1.24.52-1.86a.49.49,0,0,1,.94.26c-.18.62-.35,1.25-.54,1.87A.48.48,0,0,1,443.39,226.84Zm1.71-6.55-.11,0a.49.49,0,0,1-.37-.58c.15-.62.29-1.25.42-1.88a.48.48,0,0,1,.57-.37.47.47,0,0,1,.37.57c-.13.64-.27,1.27-.41,1.9A.49.49,0,0,1,445.1,220.29Zm1.29-6.65h-.07a.48.48,0,0,1-.4-.56c.1-.63.2-1.27.29-1.9a.47.47,0,0,1,.54-.41.48.48,0,0,1,.41.55c-.09.64-.19,1.28-.29,1.92A.48.48,0,0,1,446.39,213.64Zm.87-6.71h-.05a.48.48,0,0,1-.43-.53c.06-.64.11-1.28.16-1.92a.48.48,0,0,1,1,.07c0,.65-.1,1.3-.16,1.94A.49.49,0,0,1,447.26,206.93Zm.4-6.76h0a.47.47,0,0,1-.47-.49c0-.64,0-1.28,0-1.93a.49.49,0,0,1,.49-.48h0a.48.48,0,0,1,.48.49c0,.65,0,1.29,0,1.94A.48.48,0,0,1,447.66,200.17Zm-.08-6.76a.49.49,0,0,1-.49-.46c0-.64-.07-1.28-.11-1.92a.48.48,0,0,1,.45-.52.49.49,0,0,1,.51.45c.05.65.09,1.29.12,1.94a.49.49,0,0,1-.46.51Zm-.6-6.74a.49.49,0,0,1-.48-.43c-.08-.63-.17-1.27-.26-1.9a.48.48,0,0,1,.4-.55.49.49,0,0,1,.55.4c.1.65.19,1.29.27,1.93a.47.47,0,0,1-.42.54ZM445.86,180a.48.48,0,0,1-.48-.38c-.13-.63-.27-1.25-.42-1.87a.5.5,0,0,1,.36-.59.48.48,0,0,1,.58.36c.15.63.3,1.27.43,1.9a.47.47,0,0,1-.37.57Zm-1.69-6.55a.47.47,0,0,1-.46-.34c-.19-.61-.38-1.22-.58-1.83A.48.48,0,1,1,444,171c.21.62.4,1.24.59,1.86a.48.48,0,0,1-.32.6A.34.34,0,0,1,444.17,173.44Zm-2.25-6.38a.5.5,0,0,1-.45-.3c-.23-.6-.48-1.19-.73-1.78a.48.48,0,0,1,.25-.63.48.48,0,0,1,.64.25c.25.6.5,1.19.74,1.8a.47.47,0,0,1-.27.62A.39.39,0,0,1,441.92,167.06Zm-2.78-6.17a.46.46,0,0,1-.43-.26c-.29-.57-.59-1.14-.89-1.71a.48.48,0,0,1,.19-.65.49.49,0,0,1,.66.19c.31.58.61,1.15.9,1.73a.48.48,0,0,1-.22.65A.41.41,0,0,1,439.14,160.89Zm-3.32-5.9a.48.48,0,0,1-.41-.23c-.33-.54-.68-1.08-1-1.62a.48.48,0,0,1,.14-.67.49.49,0,0,1,.67.14c.35.54.7,1.09,1,1.64a.48.48,0,0,1-.15.67A.48.48,0,0,1,435.82,155ZM432,149.41a.49.49,0,0,1-.39-.2c-.38-.51-.77-1-1.17-1.51a.48.48,0,1,1,.75-.61c.41.51.8,1,1.2,1.54a.49.49,0,0,1-.1.68A.46.46,0,0,1,432,149.41Zm-4.32-5.21a.48.48,0,0,1-.36-.16c-.43-.47-.87-.94-1.31-1.4a.48.48,0,0,1,.69-.67c.45.47.9.94,1.34,1.42a.48.48,0,0,1,0,.68A.45.45,0,0,1,427.68,144.2Zm-4.8-4.77a.52.52,0,0,1-.33-.12c-.47-.43-.95-.85-1.44-1.27a.48.48,0,0,1-.06-.68.49.49,0,0,1,.68-.05c.5.42,1,.84,1.47,1.28a.48.48,0,0,1-.32.84Zm-5.26-4.26a.47.47,0,0,1-.28-.09c-.52-.38-1-.75-1.57-1.11a.48.48,0,1,1,.54-.79c.54.36,1.07.74,1.6,1.12a.48.48,0,0,1-.29.87ZM412,131.49a.48.48,0,0,1-.24-.06L410,130.5a.47.47,0,0,1-.2-.65.48.48,0,0,1,.65-.2c.58.3,1.14.62,1.71.94a.49.49,0,0,1,.18.66A.48.48,0,0,1,412,131.49Zm-6.05-3a.41.41,0,0,1-.19,0c-.59-.26-1.18-.5-1.77-.74a.48.48,0,1,1,.36-.9c.6.24,1.2.49,1.79.75a.49.49,0,0,1-.19.93Zm-6.33-2.4a.4.4,0,0,1-.15,0c-.6-.2-1.22-.39-1.83-.57a.49.49,0,0,1,.28-.93c.62.19,1.24.38,1.86.59a.48.48,0,0,1-.16.94Zm-6.5-1.86H393c-.62-.16-1.24-.31-1.87-.45a.48.48,0,0,1,.22-.94q.94.21,1.89.45a.48.48,0,0,1,.35.58A.49.49,0,0,1,393.07,124.2Zm-6.61-1.43h-.09l-1.9-.34a.48.48,0,0,1-.39-.56.49.49,0,0,1,.56-.4l1.91.35a.48.48,0,0,1,.38.57A.47.47,0,0,1,386.46,122.77Zm-6.67-1.13h-.08l-1.91-.29a.48.48,0,0,1-.41-.54.49.49,0,0,1,.55-.41l1.92.28a.48.48,0,0,1,.4.55A.47.47,0,0,1,379.79,121.64Zm-6.71-.94H373l-1.92-.25a.49.49,0,0,1-.41-.55.48.48,0,0,1,.54-.41l1.92.25a.49.49,0,0,1-.07,1Zm-6.71-.89h-.06l-1.92-.26a.48.48,0,0,1,.13-1l1.92.26a.49.49,0,0,1-.07,1Zm-6.7-1h-.07l-1.92-.3a.49.49,0,0,1,.15-1l1.91.3a.48.48,0,0,1-.07,1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.49,
    y: 172.88,
    width: 159.29,
    height: 100.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.39,161.17l-3.09-8.84H50.39V281.09H215.87V161.17ZM212.78,273.75H53.49V172.88H212.78Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "57.32 163.73 55.04 165.92 57.41 168.47",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.04,
    y1: 165.92,
    x2: 60.11,
    y2: 165.92,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "70.26 163.73 72.55 165.92 70.17 168.47",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.54,
    y1: 165.92,
    x2: 67.47,
    y2: 165.92,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.45,165.61a2.5,2.5,0,0,0-2.35-1.8,2.29,2.29,0,0,0,0,4.58,2.31,2.31,0,0,0,1.44-.52",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.9 165.88 83.69 165.88 83.69 163.78",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.78,
    y1: 156.9,
    x2: 97.99,
    y2: 160.21,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.04,
    y1: 156.96,
    x2: 94.73,
    y2: 160.15,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Email--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--email--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "174.78 345.12 150.22 297.19 79.2 335.71 103.88 380.96 174.78 345.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145 310.15 130.78 345.69 79.49 335.87 127.12 340.33 143.11 309.67 145 310.15",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145 310.15 130.78 345.69 79.49 335.87 127.12 340.33 143.11 309.67 145 310.15",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.45 335.55 103.88 380.96 174.78 345.12 149.92 297.5 79.45 335.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "79.45 335.55 127.12 340.33 149.92 297.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.43,
    cy: 299.46,
    r: 10.48,
    transform: "translate(-168.57 191.96) rotate(-45)",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.43,
    cy: 299.46,
    r: 10.48,
    transform: "translate(-168.57 191.96) rotate(-45)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.43,
    cy: 299.78,
    r: 10.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.43,
    cy: 296.86,
    r: 10.48,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.43,
    cy: 296.86,
    r: 10.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.91,
    y: 234.82,
    width: 56.17,
    height: 33.93,
    rx: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.91,
    y: 234.82,
    width: 56.17,
    height: 33.93,
    rx: 3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.61,
    y: 239.98,
    width: 49.03,
    height: 2.29,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.61,
    y: 245.27,
    width: 49.03,
    height: 2.29,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.61,
    y: 250.56,
    width: 49.03,
    height: 2.29,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.61,
    y: 255.85,
    width: 49.03,
    height: 2.29,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.61,
    y: 261.14,
    width: 49.03,
    height: 2.29,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.83,262.39c-8,4.45-15.48,9.49-21.92,15.92-15,14.94-22.39,35.59-33,53.85a165.92,165.92,0,0,1-42.65,48.21c-17.73,13.5-38.73,23.52-61,25.13s-45.75-6.08-60.26-23-18.09-43.3-5.84-61.87c10.1-15.3,30.12-23.38,48.07-19.4,7,1.55,13.55,4.73,20,7.88l10,4.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2,5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.29,165.6c10-4.77,21.93-6.14,32.4-2.4s19.14,12.94,20.94,23.91c1.55,9.46-2,19.23-7.74,26.89a72.1,72.1,0,0,1-15.56,14.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2,5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.84,214.09l8.76-5.48,22-26.76,17.77,14.92-22.76,25.67-3.29-2.31L232.65,224S230.78,216.71,228.84,214.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.79,208.62l-8.84,7,2.38,5s.45,6.4,4.14,8.39,13.46-4.34,13.46-4.34,1-6.73-2.39-11.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3,133.9s-15.14,29.26-24.05,31.27l-3.53,1.18s-3.18,10.08-14,11.76l1.42-8.4-7.88,7.8s-12.72-11.65-9.69-27.46l11.13.73,5-9.3s-4.23-2.37-3.22-7.07,2-9.08,6.89-5.22c0,0,10.59,5.38,19.17-2.18s10.92-8.58,15.46-5.89C199.93,121.12,198.76,131.55,203.3,133.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.23,177.51s-11.72-7.75-9.85-26.91c0,0-14.36-3.07-34.91-1.47l-61,53.61a14.16,14.16,0,0,0,10.79,9.81c8.75,1.72,30.31,3.1,30.31,3.1l8.41-7.36-19.1-7.86,29.67-17.6,0,29.45s3.34,9.9,1.41,12.35l-12.87,13s21.64,40,70.27,14.71l-5.18-27.73s8.12-2.12,3.41-6.55l7.84-12.84s8.27,29.88,15.64,37.56l41.82-18.41s-1.11-7.17-3.35-10.05L199.06,221s.49-26.55-1.43-35.19S192,168.61,184,162.77c0,0-5.33,3.75-7.89,2.47,0,0-4.63,12.91-14.39,12.87l1.55-9-7,7.5-1,.93",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.72,122.47a10.19,10.19,0,0,0-6.38,2.75c-1.8,1.53-3.29,3.39-5,5a26.84,26.84,0,0,1-18,7.34,23,23,0,0,1-4.6,11.16c-.7.91-1.52,1.93-1.33,3a4,4,0,0,0,.71,1.45l3,4.41a2.94,2.94,0,0,1,.62,1.37c.06.95-.76,1.68-1.51,2.26l-6.41,4.94s-4.34-10.67-4.12-15.44l5-9.3s-9.42-11-2-14.83,12.1,1,12.1,1,17.8-8.64,23.16-8.47S199.72,122.47,199.72,122.47Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.72,122.47a10.19,10.19,0,0,0-6.38,2.75c-1.8,1.53-3.29,3.39-5,5a26.84,26.84,0,0,1-18,7.34,23,23,0,0,1-4.6,11.16c-.7.91-1.52,1.93-1.33,3a4,4,0,0,0,.71,1.45l3,4.41a2.94,2.94,0,0,1,.62,1.37c.06.95-.76,1.68-1.51,2.26l-6.41,4.94s-4.34-10.67-4.12-15.44l5-9.3s-9.42-11-2-14.83,12.1,1,12.1,1,17.8-8.64,23.16-8.47S199.72,122.47,199.72,122.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,131.94s-9.92,24.81-23.21,33.14c0,0-.89.88-3.72,0s-9-8-11.35-11.52a13.21,13.21,0,0,1-1.55-6.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,150a7,7,0,0,0,5,4.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,134.61a6.13,6.13,0,0,0-5.82-2.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,137.13a3.82,3.82,0,0,1,4.25,1.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.68,139.5a9.12,9.12,0,0,0-2.39,3.91,6.33,6.33,0,0,0,.34,4.51,7.61,7.61,0,0,1,.82,1.79,1.36,1.36,0,0,1-.78,1.61,1.66,1.66,0,0,1-.88-.06,15.15,15.15,0,0,1-5-2.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3,133.73a18.5,18.5,0,0,0-.88-2.89c-.46-1.19-1.24-2.48-2.51-2.62a2.47,2.47,0,0,0-1.33.24,4.56,4.56,0,0,0-2.35,3.15,9.83,9.83,0,0,0,.08,4,24.14,24.14,0,0,0,.88,3.34,5.43,5.43,0,0,0,1.44,2.49,3.06,3.06,0,0,0,5.06-2.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,141.1a37.37,37.37,0,0,1-4.37,9.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.52,215.65l2.81,4.93s.18,6.87,3.7,8.27,13.9-4.22,13.9-4.22a18.68,18.68,0,0,0-1.56-11.33,99.82,99.82,0,0,0-10.44-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.83,
    y1: 226.74,
    x2: 103.19,
    y2: 216.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.02,
    y1: 228.4,
    x2: 97.73,
    y2: 218.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.65,
    y1: 200.29,
    x2: 116.56,
    y2: 178.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93,182.83c3.52-.13,5.75-.27,9.27-.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.68,
    y1: 183.05,
    x2: 109.68,
    y2: 213.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.26,162.55s8.84,2.85,14.47,22c1.86,16.54,1.37,36.75,1.37,36.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.81,207.92s10.51.37,10.26,2.16-9,3.46-9,3.46a2.68,2.68,0,0,1,.14.42s2.11,3.91-1,5.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,207.87a92.11,92.11,0,0,0-9.71,6.32L198.29,222",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.22,224s9,3.59,20.84-3.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.62,140.3c-.47,1.29-1.35,2.16-2,1.93s-.75-1.45-.29-2.74,1.34-2.16,2-1.93S188.08,139,187.62,140.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,142.45c-.46,1.3-1.34,2.16-2,1.94s-.76-1.46-.29-2.75,1.34-2.16,2-1.93S197.07,141.16,196.6,142.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.56,267.74c1.71-.08,3.47-.22,5.29-.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,250.91S112.16,267,139,267.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "243.52 213.16 254.57 222.44 277.33 196.77 259.77 181.61 237.54 208.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "259.77 181.61 257.43 202.43 237.54 208.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,130.84s13,3.32,22-4.63,11.72-3.56,11.72-3.56-2.3,7.74,2.92,11.3l12.61-11.55s-6.75-7.28-15.12-6c0,0-6.29-13.47-16.93-14.38-12.53-1.06-41.58,10.13-24.79,46.39l3-7.12s-3.13-9.74.72-12.81C164.42,126.21,165.42,130.84,165.42,130.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.56,119.11c.5.19,2.3-.46,3-.44a10.51,10.51,0,0,1,3.76.85,22,22,0,0,1,7.35,5.52c4.17,4.67,8.05,10.88,15,11.32,6.16.38,10.65-4.3,16.52-5,12.22-1.47,21.23,11,19.69,22.21-3.48,25.3-41.91,40.67-70.72,35.39-1-.18-.11-16.14-14.12-26.18,0,0,18.06-21.31,19.25-32.33S203.57,119.11,203.56,119.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,117.05s1.22-8.24-7.72-15.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67,150.78s-.21,6.17,6.57,18.3l-8,8.43s-13.16-9.46-9.46-27.75Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.27,165.08c-5.78,14.09-14.58,13-14.58,13l1.55-9s5.95-3.3,8.67-6.9c.1-.12-.11.13,0,.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.87,
    y1: 225.51,
    x2: 106.87,
    y2: 214.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.72,191l-16.16,27s1.71,1.7,1.13,3.47-4.63,3.12-4.63,3.12,5.25,27.62,5.27,27.69c.32,1.71-14.33,6.16-15.77,6.55-11.74,3.18-24.05,2.87-35-3.06a54.06,54.06,0,0,1-19.51-18.2l11.81-12.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.54,205.09s2.54,15.22,15.5,37.69l42-18.61,18.74-4.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,221.31a12.41,12.41,0,0,0-7.52,10.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,224.89a27.12,27.12,0,0,1,6.76-3.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.08,224.17c.69-2.07-3.39-10-3.39-10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79,150.28c-11.8-1.27-31-3-34.68-1.32C105.65,151.42,70,184.62,70,184.62L49.42,202.74c.32,6.54,10.79,9.81,10.79,9.81l30.31,3.1,9.27-7s-26.17-11.44-36-12.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,192s8.59,2.6,9.89,8.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.28,142.63c2.46,3.93,5.18,7.85,9,10.48a23.32,23.32,0,0,0,16.07,3.46A41.17,41.17,0,0,0,240,150.75c3.26-1.93,6.39-4.16,10-5.38s7.81-1.3,10.88.92",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.19,153.18c.17,5.69.65,11.66,3.76,16.43,2.84,4.35,7.6,7.18,12.6,8.56a30.19,30.19,0,0,0,16.93-.27c4.52-1.41,8.63-3.85,12.93-5.83s9-3.53,13.69-3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.03 319.29 257.85 310.33 265.32 306.28 254.01 285.27 222.13 301.91 233.28 322.82 240.17 319.42 253.74 326.54 257.03 319.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.51,223.8S350.16,248,349.22,256.12s-.48,12.23,3.45,15.05,11.05,3,11.05,3l-.68,4.3s-2.84-.21-5,3.09-2.16,5.45-2.16,5.45,2.74,10.81,5,11,4.58-7.39,4.58-7.39,2,10.82,3.88,10.45,19.49-12.13,19.49-12.13,1.57-8.16-2.28-12.39c0,0-1-8.09.08-11.86,0,0,7.59,1,8-6.81.36-6.92-3.29-9.88-5.49-7.06l-5.18-13,2-9.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.24,226.22l.8,1.41s-12.64,20.86-12,34.5,20.07,10,20.07,10-1.21,17.06-8.43,16L362.83,284l.52-9.52s-7.54.69-12.15-3.92-2.41-14.45,1.8-27.89,7.51-18.87,7.51-18.87Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.24,226.22l.8,1.41s-12.64,20.86-12,34.5,20.07,10,20.07,10-1.21,17.06-8.43,16L362.83,284l.52-9.52s-7.54.69-12.15-3.92-2.41-14.45,1.8-27.89,7.51-18.87,7.51-18.87Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.36,322.31a44.73,44.73,0,0,1-4.2,12.65,56.09,56.09,0,0,1-7.83,11.7l1.75,16.48,4.19,24.55,0,0-.19.14c-.25.19-.7.52-1.34,1H355.64c-1.63-3.78-3.44-8.06-5.14-12.27-3.1-7.69-5.84-15.13-6.46-18.86a9.88,9.88,0,0,1-.13-1.28L333.38,345.9l-34.75,18.92-44.8-37.91.07-.13,4.55-9.1,0-.05L303,338.9l9.23-12.76.13-.42v-.05L315,317l0-.09,1.65-5.4,2.11-6.91L332,298.34l0,0L355.84,287l0,.12c.12.41.49,1.74,1,3.35.12.39.24.78.38,1.17s.19.58.3.86a31.2,31.2,0,0,0,1.6,3.77c.1.19.21.37.31.53a5.9,5.9,0,0,0,.47.67l0,.05a1.08,1.08,0,0,0,.81.47c1.12-.09,2.47-2.53,3.42-4.58a1.54,1.54,0,0,1,.08-.19c.54-1.21.94-2.25,1.05-2.54l0-.08a1.13,1.13,0,0,1,0,.12c.15.95,1.27,7.5,2.88,9.65l.16.21a1.21,1.21,0,0,0,.82.47h0c.78,0,3.23-1.49,6.16-3.47l0,0c5.41-3.66,12.42-9,13.45-9.79l.13-.11a19.64,19.64,0,0,0,0-5.76l.17.06,28.95,11.19h0l.84.32s4.21,5.16,6.39,17.9A32.73,32.73,0,0,1,425.36,322.31Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.57 312.16 332.25 297.02 300.17 288.4 294.63 311.63 307.41 315.63 313.19 327.35 321.97 333.38 331.6 324.4 332.42 317.23 329.57 312.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "257.85 310.33 265.3 306.64 254.07 285.14 222.25 302.32 233.28 322.82 248.27 315.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "222.25 302.32 243.78 304.48 254.07 285.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "324.48 320.26 327.91 321.25 332.36 296.66 300.17 288.26 294.63 311.63 306.98 315.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "300.34 288.26 313.12 304.24 332.36 296.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.89,220.53s-12.6,28.54-13.45,40.14,10,13.31,10.1,13.33a23.52,23.52,0,0,0,12.91-1.31c3.23-1.39,5.81-4,8.5-6.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "359.63 252.77 354.54 249.94 360.48 237.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,242.8c-.37,1.13-.18,2.2.42,2.4s1.39-.55,1.76-1.68.19-2.2-.41-2.4S366.34,241.67,366,242.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.23,239.15c-.37,1.13-.19,2.21.42,2.4s1.39-.55,1.76-1.68.19-2.2-.41-2.4S356.6,238,356.23,239.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.64,255.31a8.1,8.1,0,0,1-7.3,2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.47,236.63a3.05,3.05,0,0,1,3.62.66,9,9,0,0,1,1.88,3.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.89,235a2.27,2.27,0,0,0-4.08-.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.24,256.53s3.37-5.51,6.89-4.29,1.84,6.28.15,9.5-6,3.36-8.42,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.18,259.62s3.34-5.64-.21-7.52-7.93,4.48-7.93,4.48-.45,0-.9-.16a3.23,3.23,0,0,1-1.84-4.29c.15-.35.27-.7.38-1a9.21,9.21,0,0,0,.36-4.51c-.58-3.06-2.76-5.55-2.41-8.82a21.23,21.23,0,0,1,2.27-7.32c-18.18,3.64-29.09-6.67-26.67-15.15s8.18-.91,20.91-5.76S400,225.37,400,225.37c12.73,8.79.56,21.14.56,21.14L394.07,260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.29,346.2c.47,16.05,6,41.49,6,41.49l0,0-.19.14-1.38,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.26,388.83c-1.62-3.82-3.2-7.94-4.76-12.27-2.28-6.34-4.49-13.14-6.59-20.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.05,281.88s25.87,9.19,29.81,11.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.83,289.31c-2-1.49-3.18-5.31-2.72-8.12l.64-6.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.6,264.37s-1.3,4.34-.23,12.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,356.58l-46-32.32-10,9s40.94,45.61,57.1,52.79c0,0,32.24-34.76,42.66-52,0,0,10.52-17.22-2.7-40.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.47,
    y1: 352.79,
    x2: 397.16,
    y2: 320.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.23,
    y1: 353.31,
    x2: 388.68,
    y2: 354.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.28,226.76s2-8-3-14.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "312.26 326.14 302.82 339.25 257.96 317.44 253.76 326.67 298.63 364.82 333.24 345.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.02,
    y1: 298.84,
    x2: 355.84,
    y2: 286.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.72,319.85l1.29-12-4.82-8.95s.69-6.32-.69-6.29S251.19,308,251.19,308s-4.09,2.88-2.58,9.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.92,
    y1: 319.23,
    x2: 253.77,
    y2: 326.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "329.79 312.46 332.22 316.71 331.75 324.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.42,321.54c0-.66-13.67-15.4-13.67-15.4l-1.57,1.24,5.61,11-4.7-8.26-1.32,1.57,1.23,6-1.64-4.38-2.22,1.15,6.05,12.89,8.62,5.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.47,276.51S375.76,285,365.82,288.8c0,0,1,11.47,3.44,12.23.92.29,2.33-.67,3.07-1.07a58.72,58.72,0,0,0,5.12-3.22c3.4-2.32,6.7-4.78,10-7.29.63-.49,1.59-.95,1.63-1.81.22-4,.45-8-2.53-11.09Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.82,288.8s-2.73,9.5-5,9.17-5.07-11.61-5.07-11.61,2.62-9,7.52-7.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,338.91a44.39,44.39,0,0,1,0,10.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.15,
    y1: 317.33,
    x2: 339.96,
    y2: 329.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.11,309.61a33.82,33.82,0,0,0-3.85,18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.53,316.7a40.11,40.11,0,0,0,.37,10.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,340.33a17.47,17.47,0,0,1,2,6.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.2,216.71a6.75,6.75,0,0,0,2.75,4,15.61,15.61,0,0,0,4.5,2.12,47.13,47.13,0,0,0,14.47,2.34,11.88,11.88,0,0,1,3.21.26,3.45,3.45,0,0,1,2.37,2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.9,212.83c.64,2.72,3.46,4.45,6.23,4.85s5.57-.24,8.34-.63,5.74-.5,8.21.82,4.12,4.51,2.87,7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "336.15 388.83 355.26 388.83 355.64 388.83 417.66 388.83 417.7 388.83 453.21 388.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.73,
    y1: 388.83,
    x2: 327.07,
    y2: 388.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-47--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "369.28 402.75 303.6 402.75 278.53 416.3 347.35 416.3 369.28 402.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.9,
    y1: 406.29,
    x2: 356.4,
    y2: 406.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.36,
    y1: 408.82,
    x2: 351.51,
    y2: 408.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.82,
    y1: 411.34,
    x2: 346.59,
    y2: 411.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.65,
    y1: 406.29,
    x2: 342.76,
    y2: 413.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.07,
    y1: 406.29,
    x2: 335.18,
    y2: 413.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.78 369.05 335.61 369.05 347.35 416.3 278.53 416.3 266.78 369.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.92,
    y: 416.29,
    width: 69.44,
    height: 3.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.02 369.05 334.85 369.05 346.6 416.3 277.77 416.3 266.02 369.05",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.35 416.3 369.76 402.67 369.75 405.23 347.6 420.08 347.35 416.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3,391.23a3.68,3.68,0,1,1-4.56-3A3.86,3.86,0,0,1,309.3,391.23Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsBro);
export default __webpack_public_path__ + "static/media/Emails-bro.8d3a90d8fe6b8aa214274c355a3bd4d7.svg";
export { ForwardRef as ReactComponent };